import moment from 'moment';
import { createTransferReservationBaseInitialValues } from '../../../viajeTraslado/forms/base/TransferReservationBaseFormInitialValues';
import { TransferReservationSingleFormType } from './TransferReservationSingleFormType';
import { ViajeTrasladoTipoServicio } from '../../models';

export const createTransferReservationSingleFormInitialValues =
  (): TransferReservationSingleFormType => ({
    ...createTransferReservationBaseInitialValues(),
    fechaYHoraDeLlegada: moment(),
    minutosPreviosASalida: moment(),
    puntos: [],
    prioridad: false,
    tipoServicio: ViajeTrasladoTipoServicio.EJECUTIVO,
    fixedRate: null,
    hasOutSite: false
  });
